import { createContext, useContext } from "react";
/**
 * @deprecated
 */
export const LocaleContext = createContext("en-gb");
/**
 * @deprecated
 * @param {number} fixedDecimals
 * @returns {Intl.NumberFormat}
 */
export function useIntlNumberFormat(fixedDecimals) {
    const locale = useContext(LocaleContext);
    return new Intl.NumberFormat(locale.replace("_", "-"), fixedDecimals ? { minimumFractionDigits: fixedDecimals, maximumFractionDigits: fixedDecimals } : {});
}
//# sourceMappingURL=useIntlNumberFormat.js.map